/** @format */
import { SearchFacet } from '@toucan/common/services/search/constants';
import { getSearchParamKey } from '@toucan/common/services/search/helpers';

import { SearchParam } from '@toucan/client/global/nextjs';

export function getFiltersToRemove(
    activeFilters: { id: SearchFacet }[]
): SearchParam {
    return activeFilters.reduce((filtersToRemove, activeFilter) => {
        const searchParamKey = getSearchParamKey(activeFilter.id);

        filtersToRemove[searchParamKey] = undefined;

        return filtersToRemove;
    }, {} as Record<string, undefined>);
}
